import { ClickAwayListener } from "@mui/material";
import clsx from "clsx";
import styles from "./popperStyles.module.css";
import React, { useEffect, useRef, useState } from "react";

interface Props {
  onClose: (ev: MouseEvent | TouchEvent) => Promise<void> | void;
  onKeyDown?: (ev: any) => Promise<void> | void;
  open: boolean;
  topShift?: number;
  leftShift?: number;
  widthSift?: number;
  minWidthSift?: number;
  anchorElRef: { current: any };
  children: Array<React.JSX.Element> | React.JSX.Element;
  height?: number;
}

export default function SimplePopper(props: Props) {
  const {
    onClose,
    onKeyDown,
    open,
    anchorElRef,
    children,
    height,
    topShift = 0,
    leftShift = 0,
    minWidthSift = 0,
    widthSift = 0,
  } = props;
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null);

  const positionSettings = useRef({ minWidth: 402, maxHeight: 252 });

  const popperRef = useRef<HTMLDivElement>(null);

  const initMinWidth = () => {
    if (anchorElRef.current) {
      positionSettings.current.minWidth =
        anchorElRef.current.clientWidth > 402 + minWidthSift
          ? anchorElRef.current.clientWidth + widthSift
          : 402 + minWidthSift;
    }
  };
  useEffect(initMinWidth, [anchorElRef]);

  const updatePosition = () => {
    open && setPosition(getPosition());
  };
  useEffect(updatePosition, [open, height]);

  const onClosePopper = (ev: MouseEvent | TouchEvent) => {
    onClose(ev);
  };

  const getPosition = () => {
    if (!popperRef.current || !anchorElRef.current) return { x: 0, y: 0 };
    const rootRect = document.querySelector("#root")?.getBoundingClientRect();
    const anchorRect = anchorElRef.current?.getBoundingClientRect();

    if (!rootRect || !anchorRect) return { x: 0, y: 0 };

    const width =
      positionSettings.current.minWidth < popperRef.current.clientWidth &&
      popperRef.current.clientWidth < rootRect.right / 2
        ? popperRef.current.clientWidth
        : positionSettings.current.minWidth;

    const heightChild =
      height || 0 < positionSettings.current.maxHeight ? height || 0 : positionSettings.current.maxHeight;

    const x = anchorRect.right - width + leftShift < 0 ? 30 + leftShift : anchorRect.right - width + 30 + leftShift;
    const y =
      anchorRect.top + heightChild < rootRect.bottom - 110 + topShift
        ? anchorRect.top + 27 + topShift
        : anchorRect.top - heightChild - 9 - topShift + anchorElRef.current.clientHeight;

    return { x, y };
  };

  return (
    <div
      onKeyDown={(ev) => onKeyDown?.(ev)}
      className={clsx(styles.popperContainer)}
      style={{
        zIndex:
          !anchorElRef.current || anchorElRef.current.closest(".background_ModalDialog") === null
            ? "999"
            : anchorElRef.current.closest("DIV.background_ModalDialog").style.zIndex,
        left: position?.x || 0,
        top: position?.y || 0,
      }}
    >
      {open && (
        <ClickAwayListener onClickAway={onClosePopper}>
          <div
            tabIndex={0}
            onWheel={(ev) => {
              ev.stopPropagation();
            }}
            onKeyDown={(ev) => {
              ev.stopPropagation();
            }}
            ref={popperRef}
            className={clsx(styles.popper, !position && styles.popperHidden)}
            style={{
              maxHeight: `${positionSettings.current.maxHeight}px`,
              minWidth: `${positionSettings.current.minWidth}px`,
            }}
          >
            {children}
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}
